import getOperatorCustomRoutes from '@om-fe/wm-core/src/routes/routes';

export default getOperatorCustomRoutes;
